// A dropdown list with search.
// @flow
import React, { Component } from 'react';
import DropDownSelector from './dropdown/DropDownSelector';
import DropDownButton from './dropdown/DropDownButton';

import type { Suggestion } from './dropdown/constants';

type Props = {
    onCancel?: (...any) => void,
    onSelect: (...any) => void,
    data: Array<Suggestion>,
    selected?: Suggestion,
    isOpen?: boolean
};

type State = {
    isOpen: boolean
};

export default class SearchableDropDown extends Component<Props, State> {
    static defaultProps = {
        onCancel: () => undefined,
        selected: {},
        isOpen: false
    };

    state: State = {
        isOpen: this.props.isOpen
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = (...args: any) => {
        this.setState({
            isOpen: false
        });
        this.props.onCancel(...args);
    };

    onSelect = (...args: any) => {
        this.props.onSelect(...args);
        this.setState({
            isOpen: false
        });
    };

    render() {
        if (this.state.isOpen) {
            return (
                <DropDownSelector
                    onCancel={this.close}
                    onSelect={this.onSelect}
                    options={this.props.data}
                    placeholder={this.props.placeholder}
                />
            );
        } else {
            const { image, text } = this.props.selected;
            const title = text ? text : this.props.placeholder;
            return (
                <DropDownButton
                    onClick={this.open}
                    title={title}
                    icon={image}
                />
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/common/SearchableDropDown.jsx